import React, { useState } from 'react';
import { useIntl } from 'umi';
import { getTranslateAndHighlightText } from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/NewsActivity/utils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import ExpandCollapseText from '@/pages/intelligence/components/ExpandCollapse';
import MoreModal from '@/pages/intelligence/pages/TopCharts/Companies/MoreModal';

import type { IBaseProps } from '@/pages/intelligence/types/common';
import type { ICompaniesDetailsLang } from './types';

interface IItemDomProps extends IBaseProps {
  lang: ICompaniesDetailsLang;
  keywords?: string[];
  data: any;
  onSourceClick: (e: React.SyntheticEvent<HTMLSpanElement>) => void;
}

const ItemDom: React.FC<IItemDomProps> = (porps) => {
  const { lang, keywords, data, onSourceClick } = porps;

  const { formatMessage } = useIntl();

  const [visible, setVisible] = useState(false);
  const [currentData, setCurrentData] = useState<any>({});

  return (
    <div
      className="dbi-media-news-item"
      onClick={(e) => {
        e?.stopPropagation();
        e?.preventDefault();
        setCurrentData(data);
        setVisible(true);
      }}
    >
      <div className="dbi-media-news-flex">
        {/* 高光 action-text */}
        <div className="dbi-media-news-title">
          <div className="item-title" dangerouslySetInnerHTML={{
            __html: getTranslateAndHighlightText(
              { original: data?.news, en: data?.title_en, cn: data?.title_cn },
              { lang, keywords },
            )
          }}>
            {/* {data.title.substr(0, data.title.indexOf('Tencent'))} */}
            {/* <span className="action-text">Tencent</span> */}
            {/* {data.title.substr('Tencent'.length - 1)} */}
            {/* {getTranslateAndHighlightText(
              { original: data?.news, en: data?.title_en, cn: data?.title_cn },
              { lang, keywords },
            )} */}
          </div>
          <div className="item-share">
            <SvgIcon
              type="other-share-icon"
              onClick={(e) => {
                e?.stopPropagation();
                e?.preventDefault();
                window.open(data?.url);
              }}
            />
          </div>
        </div>
        <div className="item-flex">
          <span className="text-desc" onClick={onSourceClick}>
            {/* {data.desc} */}
            {data?.news_type}
          </span>
          {/* <span className="text-time">{data.time}</span> */}
          <span className="text-time">{data?.posted_on}</span>
        </div>
      </div>
      <ExpandCollapseText
        className="dbi-media-news-context"
        otherText="More"
        // text={data.text}
        text={getTranslateAndHighlightText(
          { original: data?.content, en: data?.content_en, cn: data?.content_cn },
          { lang, keywords },
        )}
        onClick={() => {
          setCurrentData(data);
          setVisible(true);
        }}
      />
      <MoreModal
        title={formatMessage({ id: 'dbi_company_media_news' })}
        lang={lang}
        keywords={keywords}
        visible={visible}
        data={currentData}
        close={() => setVisible(false)}
      />
    </div>
  );
};

export default ItemDom;
